import { Appl } from '../../../core/Appl';
import { NavItem } from '../../../core/services/Models';
import { RetirementCalcService } from './RetirementCalcService';
import RetirementCalcViewModel from './calculator/RetirementCalcViewModel';

export default class RetirementCalcModule {
  public static MenuItems(): Array<NavItem> {
    const menuItems: Array<NavItem> = [];
    return menuItems;
  }

  public static init(): void {
    Appl.Services.add('IRetirementCalcService', RetirementCalcService);
    Appl.Services.add('RetirementCalcViewModel', RetirementCalcViewModel);
  }
}
